import React, { useEffect } from "react";
import SearchBar from "material-ui-search-bar";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles({
  flexGrow: {
    flex: "1",
  },
  searchButton: {
    "& button": {
      "&:hover": {
        backgroundColor: "white",
      },
    },
  },
});

const SearchBarBox = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  const [searchValue, setSearchValue] = useState("");
  const [searchByValue, setSearchByValue] = useState("all");
  let {} = useParams();

  useEffect(() => {
    if (location.pathname.slice(1, 7) !== "search") {
      setSearchValue("");
      setSearchByValue("all");
    }
  }, [location.pathname]);

  const requestHandler = () => {
    if (searchValue === "") return;
    navigate(`/search/${searchByValue}/${searchValue}`);
  };

  return (
    <>
      <div class="btn-group">
        <SearchBar
          className={classes.searchButton}
          value={searchValue}
          onRequestSearch={requestHandler}
          onCancelSearch={() => setSearchValue("")}
          onChange={(value) => setSearchValue(value)}
          style={{
            margin: "0 auto",
            maxWidth: 300,
            minWifth: 200,
          }}
          searchIcon={<SearchIcon style={{ display: "none" }} />}
        />

        <select
          className="form-control"
          name="ownerTechnology"
          style={{
            width: "120px",
            height: "48px",
            fontSize: ".8vw",
            margin: "auto",
          }}
          value={searchByValue}
          onChange={(searchVal) =>
            setSearchByValue(searchVal.target.value.toString())
          }
        >
          <option value="all">All</option>
          <option value="sites">Sites</option>
          <option value="pools">Pools</option>
          <option value="ranges">Ranges</option>
          <option value="endpoints">Endpoints</option>
        </select>

        <Button
          variant="text"
          size="medium"
          style={{
            color: "white",
            height: "48px",
            fontSize: ".8vw",
            margin: "auto",
          }}
          onClick={requestHandler}
        >
          <SearchIcon />
        </Button>
      </div>
    </>
  );
};

export default SearchBarBox;
